export default __webpack_public_path__ + "static/media/hht2_ep19_timeline_05.e88746b6.png";